var INTERNET_CONNECTION_STATUS = {
  RESTORED: 'RESTORED',
  LOST: 'LOST',
  CONNECTED: 'CONNECTED',
  PENDING: 'PENDING'
};
export default INTERNET_CONNECTION_STATUS;